'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { CardError } from '@/components/common/Card';
import { useDashboardContext } from '@/contexts/Dashboard/Dashboard.context';
const BorrowApyCardError = () => {
  const $ = _c(4);
  const {
    isSmallDashboard,
    isDashboardExpanded
  } = useDashboardContext();
  const t0 = isDashboardExpanded ? "Something went wrong while loading the Rate card." : "Something went wrong.";
  let t1;
  if ($[0] !== isDashboardExpanded || $[1] !== isSmallDashboard || $[2] !== t0) {
    t1 = <CardError message={t0} isSmall={isSmallDashboard} isExpanded={isDashboardExpanded} />;
    $[0] = isDashboardExpanded;
    $[1] = isSmallDashboard;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default memo(BorrowApyCardError);